export const DropshipperServiceEnum = {
    PROM: 'prom',
    ROZETKA: 'rozetka',
    HOROSHOP: 'horoshop',
    IC: '1c',
    NCASE_1: 'ncase-1',
    KOSMOTECH: 'kosmotech',
    KOSMOTECH_NEW: 'kosmotech-new',
    ITSELLOPT: 'itsellopt',
    LUGI: 'lugi',
    MOBILOZ: 'mobiloz',
    MMA: 'mma',
    GOOGLE_SHOPPING: 'google-shopping',
    DEVICE_MARKET: 'device-market',
    SANDI: 'sandi',
    TOYSI: 'toysi',
    KARAMAN: 'karaman'
} as const;

export type DropshipperService = typeof DropshipperServiceEnum[keyof typeof DropshipperServiceEnum];
